
export default {
  /*积分配置缓存 */
  pointconfigKey:'__xr_pointconfig',  
  addPointconfig : function(sc){
    this.delPointconfig()
    if(typeof(sc) == "object"){
      sc = JSON.stringify(sc)
    }
    window.localStorage.setItem(this.pointconfigKey, sc)
  },
  getPointconfig : function(){
    var sc = window.localStorage.getItem(this.pointconfigKey)
    if(sc){
      return JSON.parse(sc)
    }
    return {}
  },
  delPointconfig : function(){
    return window.localStorage.removeItem(this.pointconfigKey)
  }
}



// WEBPACK FOOTER //
// ./src/util/pointconfigCache.js